
import Vue from 'vue'
const BUS = new Vue()

export default BUS
